import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';
import {ProtocolCommand} from '../../../service-model/protocol-command.interface';

export class RemovePnLChartSubscription implements ProtocolCommand {
  constructor(public readonly subscriptions: string[]) {}

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.RemovePnLChartSubscription`;
  }
}
